/*
 * @Description:
 * @Author: fiveonelei
 * @Date: 2022-02-18 14:08:40
 * @FilePath: /app-monorepo-projects/packages/app-share/src/utils/formatter.ts
 */
import { MetaFeed, MetaPerson } from '@/types/feed';
import { EFeedReserveType } from '@/constants/feed';
import { MetaCollection } from '@/types/collection';
import {
  ModelMetaFeed,
  ModelGoodsDisplayInfo,
  ModelGoodsInfo,
  ModelAdInfo,
  ModelExposureMaterialInfo,
  ModelCollectionInfo,
} from '@/types/model';
import { IHashMap } from '@/types/data';
import { GoodsDisplayInfo, GoodsInfo, AdInfo } from '@/types/services/fetch-native-ad';

export function formatFeed(feed: MetaFeed, index: number): ModelMetaFeed {
  const reserve = feed.reserve || {};
  const { businessCard, exposureMaterialInfo, business } = EFeedReserveType;
  return {
    index,
    id: feed.id,
    posterId: feed.poster_id,
    poster: formatPoster(feed.poster),
    video: {
      fileId: feed.video?.file_id,
      duration: feed.video?.duration || 0,
      height: feed.video?.height,
      width: feed.video?.width,
    },
    images: feed.images,
    dingCount: feed.ding_count,
    totalCommentNum: feed.total_comment_num,
    materialDesc: feed.material_desc,
    isDing: feed.is_ding,
    playNum: feed.playNum,
    videoUrl: feed.video_url,
    videoCover: feed.video_cover?.static_cover?.url || '',
    reserve: {
      [businessCard]: reserve[businessCard],
      [exposureMaterialInfo]: formatExposureMaterialInfo(reserve[exposureMaterialInfo]),
      [business]: reserve[business],
    },
    shareInfo: {
      bodyMap: feed.share_info?.body_map || {}, // 这个bodyMap字段的嵌套类型太深了，而且它的原始类型就是iHashMap就不做format
      jumpUrl: feed.share_info?.jump_url || '',
    },
    topicId: feed.topic_id,
    topic: feed.topic,
    feedDesc: feed.feed_desc,
    geoInfo: feed.geoInfo,
    musicId: feed.music_id,
    feedDescWithat: feed.feed_desc_withat,
    feedRecommendReason: feed.feed_recommend_reason,
    externInfo: {
      mpEx: {
        collectionIndex: feed.extern_info?.mpEx?.collection_index,
        collectionEvent: feed.extern_info?.mpEx?.collection_event,
      },
    },
    collectionId: feed.collectionId,
    richDing: { h5RichDingDisplay: feed.richDing.h5RichDingDisplay },
    videoConfig: feed.videoConfig || {},
    videoSpecUrls: feed.video_spec_urls,
    useF0: feed.useF0,
  };
}

export function formatGoodsDisplayInfo(displayInfo: GoodsDisplayInfo): ModelGoodsDisplayInfo {
  return {
    buttonTxt: displayInfo.button_txt,
    cardImg: displayInfo.card_img,
    cardTitle: displayInfo.card_title,
    cardButtonTxt: displayInfo.card_button_txt,
  };
}

export function formatGoodsInfo(goodsInfo: GoodsInfo): ModelGoodsInfo {
  return {
    tags: goodsInfo.tags,
    price: goodsInfo.price,
    sales: goodsInfo.sales,
    hasCoupon: goodsInfo.has_coupon,
  };
};

export function formatAdInfo(adInfo: AdInfo): ModelAdInfo {
  return {
    traceInfo: adInfo.trace_info,
    goodsMaterialInfo: {
      goodsInfo: formatGoodsInfo(adInfo.goods_material_info?.goods_info),
      displayInfo: formatGoodsDisplayInfo(adInfo.goods_material_info?.display_info),
    },
  };
}

export function formatPoster(poster: MetaPerson): MetaPerson {
  return {
    id: poster.id,
    type: poster.type,
    uid: poster.uid,
    createtime: poster.createtime,
    nick: poster.nick,
    avatar: poster.avatar,
  };
}

export function formatCollectionInfo(collectionInfo: MetaCollection|null): ModelCollectionInfo|null {
  if (!collectionInfo) return null;
  return {
    name: collectionInfo.name,
    feedNum: collectionInfo.feedNum,
    playNum: collectionInfo.playNum,
    keyWord: collectionInfo.keyWord,
    collectionType: collectionInfo.collectionType,
  };
}
export function formatExposureMaterialInfo(exposureMaterialInfo = ''): ModelExposureMaterialInfo {
  let result: IHashMap = {
  };
  try {
    result = JSON.parse(exposureMaterialInfo);
  } catch (err) {
  }
  return {
    schemeMultiStyle: result.scheme_multi_style || '',
    schemeDynamicStyleIcon: result.scheme_dynamic_style_icon || '',
    schemeDynamicStyleText: result.scheme_dynamic_style_text || '',
    iconDynamicStyle: result.icon_dynamic_style || '',
    textDynamicStyle: result.text_dynamic_style || '',
    exposureMaterialName: result.exposure_material_name || '',
    materialId: result.material_id || '',
    h5ShareTitleContent: result.h5_share_title_content || '',
    h5ShareButtonContent: result.h5_share_button_content || '',
    commonLabelScheme: result.common_label_scheme || '',
    materialCategory: result.material_category || '',
    iosMinVersionStr: result.ios_min_version_str || '',
    androidMinVersionStr: result.android_min_version_str || '',
  };
};
